import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {User} from '../models';
import {Observable} from 'rxjs/Observable';
import {UserGroup} from "../models/user-group";

@Injectable()
export class UserService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  public getCurrentUser(): Observable<User> {
    return this.http.get<User>(this.baseUrl + '/api/user/full/');
  }
  public getCurrentUserGroup(): Observable<UserGroup>{
    return this.http.get<UserGroup>(this.baseUrl + '/api/user/group/');
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/user.service.ts